import Echo from "laravel-echo";
import { PresenceChannel } from "laravel-echo/dist/channel";
import { EVENTS } from "../EVENTS";
import { Controller } from "../Controller";
import {v1} from "uuid";
import { ApiLocation } from "../../const/ApiLocation";

export class Comm
{


    static apiUrl: string;
    static gameId: number;
    static token: string;

    static chatChannelId: string;
    
    static echo: Echo;
    static presenceChannel: PresenceChannel;
    static connected: boolean;

    static socketUrl: string;
    static socket: WebSocket;

    static pageVisible: boolean;
    static disconnectTimeout: number;

    static errored: boolean;

    static reconnectTimeoutId: ReturnType<typeof setInterval>;

    static pingIntervalId: ReturnType<typeof setInterval>;
    static pingTimeoutId: ReturnType<typeof setInterval>;
    static pingTimeouted: boolean;

    static serviceRestarted: boolean;

    static config = {
        pingInterval: 15000,
        pingTimeout: 14000,
        pingSocketRestart: 30000,
        disconnectTimeout: 15000
    }

    static warning: string;

    static listeners: Record<string, Array<{
        callback: (data: any, init: boolean, serviceRestarted: boolean) => void,
        scope: any,
        once: boolean
    }>> = {};

    
    static init(apiUrl: string, game_id: number, token: string)
    {
        this.apiUrl = apiUrl;
        this.gameId = game_id;
        this.token = token;

        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.ping = this.ping.bind(this);
        this.pong = this.pong.bind(this);
        this.pingTimeout = this.pingTimeout.bind(this);
        this.errored = false;
        this.serviceRestarted = false;
        this.pingTimeouted = false;
        this.pageVisible = true;
        this.connected = false;
        
        this.onChatConnected = this.onChatConnected.bind(this);
        this.onChatChannelMessage = this.onChatChannelMessage.bind(this);
        this.onChatPlayersCount = this.onChatPlayersCount.bind(this);
        this.onChatPlayersJoin = this.onChatPlayersJoin.bind(this);
        this.onChatPlayersLeave = this.onChatPlayersLeave.bind(this);

        document.addEventListener("visibilitychange", this.onVisibilityChange);

        this.connect();
    }


    static getGameInfo()
    {
        const xml = new XMLHttpRequest();
        xml.open("POST", this.apiUrl + ApiLocation.REFRESH);
        xml.responseType = "text";
        xml.setRequestHeader("content-type", "application/json");
        
        xml.onreadystatechange = () => {

            if (xml.readyState === 4)
            {
                if (xml.status === 200)
                {
                    Comm.onGameInfo(JSON.parse(xml.response));
                }
                else
                {
                    this.connected = false;
                    
                    if (this.pageVisible)
                    {
                        this.reconnectTimeoutId = setTimeout(this.connect.bind(this), 1000);
                        Comm.emit(Comm.CONNECTION.RECONNECTING, null);
                    }
                    else
                    {
                        Comm.emit(Comm.CONNECTION.DISCONNECTED, null);
                    }
                }
            }
        };

        xml.send(JSON.stringify({
            hash: this.token,
            game_id: this.gameId
        }));
    }


    static onGameInfo(data: Comm.ResponseTypes.GameInfo)
    {
        if (data.status !== "OK")
        {
            EVENTS.emit(EVENTS.GAME.CRITICAL_ERROR);

            Comm.emit(Comm.CONNECTION.DISCONNECTED, null);

            this.close(1000);
            
            return;
        }

        this.socketUrl = data.result.game.socket_url;
        this.chatChannelId = data.result.chat.channel;

        if (!this.echo)
        {
            this.echo = new Echo({
                broadcaster: 'socket.io',
                host: this.apiUrl,
                logToConsole: true,
                transports: ['websocket'],
                client: require("socket.io-client"),
                auth: {
                    headers: {
                        Token: this.token,
                        Accept: "application/json"
                    }
                }
            });
    
            this.presenceChannel = this.echo.join(this.chatChannelId);
            // @ts-ignore
            this.presenceChannel.listen(".server.chat_message", this.onChatChannelMessage);
            this.presenceChannel.here(this.onChatPlayersCount);
            this.presenceChannel.joining(this.onChatPlayersJoin);
            this.presenceChannel.leaving(this.onChatPlayersLeave);
    
            this.echo.connector.socket.once("connect", () => {
                this.echo.connector.socket.on("connect", this.onChatConnected);
            });
        }

        this.emit(Comm.RESPONSE.GAME_INFO, data);
        
        this._connect();
    }


    static onVisibilityChange()
    {
        if (document.visibilityState == "hidden")
        {
            this.pageVisible = false;
            
            clearTimeout(this.reconnectTimeoutId);
            if (this.serviceRestarted)
            {
                this.serviceRestarted = false;
                this.close();
            }
            else if (this.connected)
            {
                this.disconnectTimeout = setTimeout(this.close.bind(this), this.config.disconnectTimeout);
            }
        }
        else
        {
            this.pageVisible = true;
            
            clearTimeout(this.disconnectTimeout);
            this.disconnectTimeout = null;

            if (!this.connected)
            {
                Comm.emit(Comm.CONNECTION.RECONNECTING, null);

                this.connect()
            }
        }
    }


    static connect()
    {
        if (this.connected || this.errored)
        {
            return;
        }

        this.connected = true;

        this.getGameInfo();
    }


    private static _connect()
    {
        this.connected = true;

        console.log("socket._connect: " + this.socket?.readyState);
        if (!this.socket || this.socket.readyState == WebSocket.CLOSED)
        {
            this.socket = new WebSocket(this.socketUrl + "?token=" + this.token);
            
            this.socket.addEventListener("message", this.onMessage);
            this.socket.addEventListener("open", this.onOpen);
            this.socket.addEventListener("close", this.onClose);
        }

        if (!this.echo.connector.socket.connected)
        {
            this.echo.connector.socket.connect();
        }
    }


    static close(code: number = this.errored ? 1000 : 1006)
    {
        console.log("Socket.close: ");

        clearInterval(this.pingIntervalId);
        clearTimeout(this.pingTimeoutId);

        if (this.socket && this.socket.readyState !== WebSocket.CLOSED)
        {
            this.socket.close();
        }

        if (this.echo)
        {
            this.echo.disconnect();
        }

        this.onClose(new CloseEvent("close", {code: code}));
    }


    static fixData(event: string, data: any)
    {
        if (event == this.RESPONSE.LEADERBOARD && (data as Comm.ResponseTypes.Leaderboard).type != "multipliers")
        {
            (Object.values(data.data) as Array<Comm.ResponseTypes.BetData>).forEach((bet) => {
                if (bet.player_id)
                {
                    bet.player_avatar = Controller.getAvatarForUser(bet.player_id.toString());
                }
                bet.bet_amount = (Math.floor(Number(bet.bet_amount || 0) * 100) * .01).toFixed(2);
                bet.win_amount = (Math.floor(Number(bet.win_amount || 0) * 100) * .01).toFixed(2);
                bet.crashpoint = (Math.floor(Number(bet.crashpoint || 0) * 100) * .01).toFixed(2);
                bet.multiplier = (Math.floor(Number(bet.multiplier || 0) * 100) * .01).toFixed(2);
                bet.currency = currency;
            });
        }
        else if (event == this.RESPONSE.CASHOUT)
        {
            const _data = data as Comm.ResponseTypes.Cashout;

            if (!_data.error)
            {
                _data.multiplier = Number(_data.multiplier || 0).toFixed(2)
                _data.win_amount = Number(_data.win_amount || 0).toFixed(2)
            }

        }
        else
        {
            const keys = [
                "active_player_bets",
                "all_bets",
                "bets",
                "previous_round_bets"
            ];
            
            keys.forEach(key => {
                if (data[key])
                {
                    (Object.values(data[key]) as Array<Comm.ResponseTypes.BetData>).forEach((bet) => {
                        if (bet.player_id)
                        {
                            bet.player_avatar = Controller.getAvatarForUser(bet.player_id.toString());
                        }
                        bet.bet_amount = (Math.floor(Number(bet.bet_amount || 0) * 100) * .01).toFixed(2);
                        bet.win_amount = (Math.floor(Number(bet.win_amount || 0) * 100) * .01).toFixed(2);
                        bet.crashpoint = (Math.floor(Number(bet.crashpoint || 0) * 100) * .01).toFixed(2);
                        bet.multiplier = (Math.floor(Number(bet.multiplier || 0) * 100) * .01).toFixed(2);
                        bet.currency = currency;
                    });
                }
            })
        }

        if (event == Comm.RESPONSE.MY_BETS)
        {
            (Object.values(data.bets) as Array<Comm.ResponseTypes.BetData>).forEach(bet => {
                bet.player_id = Number(Controller.player.id);
                bet.username = Controller.player.name[0] + "***" + Controller.player.name[Controller.player.name.length - 1];
            })
        }
    }


    static onMessage(event: MessageEvent<string>)
    {
        if (document.visibilityState == "hidden")
        {
            Controller.handlePassedTweens();
        }

        if (this.pingTimeouted)
        {
            this.pong();
            return;
        }

        const data = JSON.parse(event.data);
        
        this.fixData(data.event, data.args);

        if (data.event == Comm.RESPONSE.PONG)
        {
            this.pong();
        }
        else if (data.event == Comm.RESPONSE.INITIALIZE)
        {
            this.emit(this.CONNECTION.CONNECTED, null);
        }
        else if (data.event == Comm.RESPONSE.ERROR)
        {
            this.error(data.args);
        }

        this.emit(data.event, data.args);
        if (data.event == Comm.RESPONSE.GAME_STATE)
        {
            const event = (data.event + "." + data.args.state) as keyof Comm.SocketEventMap;
            this.emit(event, data.args);
        }

        if (data.event == Comm.RESPONSE.INITIALIZE)
        {
            this.emit(Comm.RESPONSE.GAME_STATE, data.args, true, this.serviceRestarted);
            const event = (Comm.RESPONSE.GAME_STATE + "." + data.args.state) as keyof Comm.SocketEventMap;
            this.emit(event, data.args, true, this.serviceRestarted);
            this.serviceRestarted = false;
        }
    }

    
    static onOpen(event: Event)
    {
        console.log("Socket.onOpen: ");
        this.emit(this.CONNECTION.RECONNECTED, null);
        this.pingTimeouted = false;
        this.pingIntervalId = setInterval(this.ping, this.config.pingInterval);
    }


    static onClose(event: CloseEvent)
    {
        console.log("Socket.onClose: " + event.code, event);
        
        clearInterval(this.pingIntervalId);
        clearTimeout(this.pingTimeoutId);
        clearTimeout(this.disconnectTimeout);
        clearTimeout(this.reconnectTimeoutId);

        if (this.socket)
        {
            this.socket.removeEventListener("message", this.onMessage);
            this.socket.removeEventListener("open", this.onOpen);
            this.socket.removeEventListener("close", this.onClose);
        }

        this.emit(Comm.RESPONSE.GAME_STATE, {
            state: "disconnected",
            plane: null
        });
        
        if (this.pageVisible)
        {
            if (event.code === 1012)
            {
                this.serviceRestarted = true;
                this.reconnectTimeoutId = setTimeout(this._connect.bind(this), 2000);
            }
            else if (event.code !== 1000)
            {
                this.connected = false;
                
                if (event.code !== 500)
                {
                    Comm.emit(Comm.CONNECTION.RECONNECTING, null);
                }

                this.reconnectTimeoutId = setTimeout(this.connect.bind(this), 1000);
            }
        }
        else if (event.code !== 1000)
        {
            this.connected = false;
            Comm.emit(Comm.CONNECTION.DISCONNECTED, null);
        }
    }


    static onChatConnected()
    {
        // @ts-ignore
        this.presenceChannel.subscribe();
    }

    
    static send<K extends keyof Comm.SocketRequestMap>(action: K, data: Comm.SocketRequestMap[K], uuid?: boolean): string | null
    {
        let reqData: any = {};
        if (uuid)
        {
            reqData.uuid = v1();
        }

        // TODO: handle closed socket responses...
        Object.assign(reqData, data);
        this.socket.send(JSON.stringify({
            action: action,
            parameters: reqData
        }));

        return reqData.uuid;
    }


    static sendChatMessage(message: string, callback: (data?: any) => void, callbackscope: any)
    {
        const xml = new XMLHttpRequest();
        xml.open("POST", this.apiUrl + ApiLocation.CHAT);
        xml.responseType = "text";
        xml.setRequestHeader("content-type", "application/json");

        xml.onreadystatechange = function ()
        {
            if (xml.readyState === 4)
            {
                if (xml.status === 200)
                {
                    callback.call(callbackscope, JSON.parse(xml.response));
                }
                else
                {
                    console.log("send chat message error: ", xml.response);
                    callback.call(callbackscope, JSON.parse(xml.response));
                }
            }
        }

        xml.send(JSON.stringify({
            hash: this.token,
            channel: this.chatChannelId,
            message: message
        }));
    }


    static error(data: any)
    {
        console.log("Socket.error: ", data);
        this.errored = true;
        // PIXI.app.stage.addChild(new ErrorView(data.type));
    }


    static ping()
    {
        this.send(Comm.REQUEST.PING, {});
        if (!this.pingTimeouted)
        {
            this.pingTimeoutId = setTimeout(this.pingTimeout, this.config.pingTimeout);
        }
    }


    static pingTimeout()
    {
        console.log("Socket.pingTimeout: ");
        this.pingTimeouted = true;

        this.emit(this.CONNECTION.LOST, null);

        this.reconnectTimeoutId = setTimeout(this.pong, this.config.pingSocketRestart);
        
        // this.showConnectionWaitingError();
        
        // clearInterval(this.pingIntervalId);
        // clearTimeout(this.pingTimeoutId);
        
        // this.pingIntervalId = setInterval(this.ping, 500);
    }


    static pong()
    {
        console.log("Socket.pong: ");
        clearTimeout(this.pingTimeoutId);
        if (this.pingTimeouted)
        {
            this.pingTimeouted = false;
            
            clearInterval(this.pingIntervalId);
            this.pingTimeouted = false;
            
            this.close(500);
        }
    }


    // #chat_area
    
    static onChatChannelMessage(data: Comm.ResponseTypes.Chat)
    {
        this.emit(Comm.RESPONSE.CHAT, data)
    }


    static onChatPlayersCount(data: Comm.ResponseTypes.ChatPlayersCount)
    {
        this.emit(Comm.RESPONSE.CHAT_PLAYERS_COUNT, data);
    }


    static onChatPlayersJoin(data: Comm.ResponseTypes.ChatPlayersCount)
    {
        this.emit(Comm.RESPONSE.CHAT_PLAYERS_JOIN, data);
    }


    static onChatPlayersLeave(data: Comm.ResponseTypes.ChatPlayersCount)
    {
        this.emit(Comm.RESPONSE.CHAT_PLAYERS_LEAVE, data);
    }


    // END #chat_area

    static on<K extends keyof Comm.SocketEventMap>(event: K, listener: Comm.Listener<K>, scope: any, prepend: boolean = false, once: boolean = false)
    {
        if (!this.listeners[event])
        {
            this.listeners[event] = [];
        }

        if (prepend)
        {
            this.listeners[event].unshift({
                callback: listener,
                scope: scope,
                once: once
            });
        }
        else
        {
            this.listeners[event].push({
                callback: listener,
                scope: scope,
                once: once
            });
        }
    }


    static once<K extends keyof Comm.SocketEventMap>(event: K, listener: Comm.Listener<K>, scope: any, prepend: boolean = false)
    {
        this.on(event, listener, scope, prepend, true);
    }


    static off<K extends keyof Comm.SocketEventMap>(event: K, listener: Comm.Listener<K>, scope: any)
    {
        if (!this.listeners[event])
        {
            return;
        }

        const idx = this.listeners[event].findIndex(l => l.callback == listener && l.scope == scope);
        if (idx !== -1)
        {
            this.listeners[event].splice(idx, 1);
        }
    }


    static emit<K extends keyof Comm.SocketEventMap>(event: K, data: Comm.SocketEventMap[K], init?: boolean, serviceRestarted?: boolean)
    {
        if (!this.listeners[event])
        {
            return;
        }

        for (let i = 0; i < this.listeners[event].length; i++)
        {
            const listener = this.listeners[event][i];
            listener.callback.call(listener.scope, data, !!init, this.serviceRestarted);
            if (listener.once)
            {
                this.listeners[event].splice(i--, 1);
            }
        }
    }


}

export namespace Comm
{

    export type Listener<K extends keyof Comm.SocketEventMap> = (data: Comm.SocketEventMap[K], init: boolean, serviceRestarted: boolean) => void;

    export type State = "in_progress" | "crash" | "starting" | "start" | "disconnected" | "init";
    export type LeaderboardType = "huge_wins" | "biggest_wins" | "multipliers";
    export type LeaderboardPeriod = "day" | "month" | "year";
    export type BetError = "INVALID_GAME_STATE" | "INSUFFICIENT_FUNDS" | "NETWORK_ERROR" | "BET_LIMIT_EXCEEDED" | "CRITICAL_ERROR";
    export type CashoutError = "INVALID_GAME_STATE" | "CASHOUT_ALREADY_PROCESSED";


    export class REQUEST
    {
        static readonly PING = "aviator.ping";

        static readonly BET = "aviator.place-bet";
        static readonly CANCEL = "aviator.cancel-bet";
        static readonly CASHOUT = "aviator.cashout";

        static readonly MY_BETS = "aviator.my_bets";
        static readonly PREVIOUS_BETS = "aviator.previous_round_bets";
        static readonly LEADERBOARD = "aviator.leaderboard";

        static readonly GIFS = "aviator.get_gifs";
    }


    export class RESPONSE
    {
        static readonly GAME_INFO = "aviator.game_info";
        
        static readonly PONG = "aviator.pong";

        static readonly INITIALIZE = "aviator.init";
        
        static readonly GAME_STATE = "aviator.game_state";
        static readonly GAME_STATE_STARTING = "aviator.game_state.starting";
        static readonly GAME_STATE_START = "aviator.game_state.start";
        static readonly GAME_STATE_IN_PROGRESS = "aviator.game_state.in_progress";
        static readonly GAME_STATE_CRASH = "aviator.game_state.crash";

        static readonly CASHED_IN = "aviator.cashed_in";
        static readonly CASHED_OUT = "aviator.cashed_out";

        static readonly BET = "aviator.bet_response";
        static readonly CANCEL_BET = "aviator.cancel_bet_response";
        static readonly CASHOUT = "aviator.cashout_response";

        static readonly MY_BETS = "aviator.my_bets_response";
        static readonly PREVIOUS_BETS = "aviator.previous_round_bets_response";
        static readonly LEADERBOARD = "aviator.leaderboard_response";
        
        static readonly ONLINE_PLAYERS = "aviator.online_players";
        static readonly ERROR = "error";

        static readonly BALANCE_UPDATE = "player.balance_updated";

        static readonly CHAT = "chat";
        static readonly CHAT_PLAYERS_COUNT = "chat.here";
        static readonly CHAT_PLAYERS_JOIN = "chat.joining";
        static readonly CHAT_PLAYERS_LEAVE = "chat.leaving";

        static readonly GIFS = "aviator.get_gifs_response";
    }


    export class CONNECTION
    {
        static readonly CONNECTED = "connection.connected";
        static readonly DISCONNECTED = "connection.disconnected";
        static readonly LOST = "connection.lost";
        static readonly BACK = "connection.back";
        static readonly RECONNECTING = "connection.reconnecting";
        static readonly RECONNECTED = "connection.reconnected";
    }


    export interface SocketRequestMap
    {
        "aviator.ping": {};
        "aviator.place-bet": RequestTypes.Bet;
        "aviator.cancel-bet": RequestTypes.Cancel;
        "aviator.cashout": RequestTypes.Cashout;
        "aviator.my_bets": RequestTypes.MyBets;
        "aviator.previous_round_bets": RequestTypes.PreviousBets;
        "aviator.leaderboard": RequestTypes.Leaderboard;
        "aviator.get_gifs": RequestTypes.Gifs;
    }


    export interface SocketEventMap
    {
        "aviator.game_info": ResponseTypes.GameInfo;

        "aviator.pong": ResponseTypes.Pong;
        "aviator.init": ResponseTypes.Init;

        "aviator.game_state": ResponseTypes.GameState;
        "aviator.game_state.starting": ResponseTypes.GameStateStarting;
        "aviator.game_state.start": ResponseTypes.GameState;
        "aviator.game_state.in_progress": ResponseTypes.GameState;
        "aviator.game_state.crash": ResponseTypes.GameState;

        "aviator.cashed_in": ResponseTypes.CashedIn;
        "aviator.cashed_out": ResponseTypes.CashedOut;

        "aviator.bet_response": ResponseTypes.Bet;
        "aviator.cancel_bet_response": ResponseTypes.CancelBet;
        "aviator.cashout_response": ResponseTypes.Cashout;

        "aviator.my_bets_response": ResponseTypes.MyBets;
        "aviator.previous_round_bets_response": ResponseTypes.PreviousBets;
        "aviator.leaderboard_response": ResponseTypes.Leaderboard;

        "player.balance_updated": ResponseTypes.BalanceUpdate;
        
        "error": ResponseTypes.Error;

        "chat": ResponseTypes.Chat;

        "chat.here": ResponseTypes.ChatPlayersCount;
        "chat.joining": ResponseTypes.ChatPlayer;
        "chat.leaving": ResponseTypes.ChatPlayer;

        "aviator.get_gifs_response": ResponseTypes.Gifs;

        "connection.connected": null;
        "connection.disconnected": null;
        "connection.lost": null;
        "connection.back": null;
        "connection.reconnected": null;
        "connection.reconnecting": null;
    }


    export namespace RequestTypes
    {

        export interface Bet
        {
            amount: number;
            cashout_at?: number;
        }

        export interface Cancel
        {
            bet_id: number;
        }

        export interface Cashout
        {
            bet_id: number;
        }

        export interface MyBets
        {
            last_bet_id?: number; 
        }

        export interface PreviousBets
        {
            
        }

        export interface Leaderboard
        {
            type: LeaderboardType;
            period: LeaderboardPeriod;
        }

        export interface Gifs
        {
            query?: string;
        }

    }


    export namespace ResponseTypes
    {

        interface Response
        {
            uuid?: string;
        }

        export interface GameInfo
        {
            status: "OK" | "ERROR";
            result: {
                chat: {
                    channel: string;
                    history: Array<Comm.ResponseTypes.Chat>;
                };
                errorId: string;
                errorType: "INVALID_SESSION" | string;
                game: {
                    socket_url: string;
                    history: Array<History>;
                    limits: {
                        bet: {
                            min: number;
                            max: number;
                        };
                        cashout_at: {
                            min: number;
                            max: number;
                        };
                        coin_denominations: Array<number>;
                        max_bets: number;
                    };
                };
                player: {
                    balance: number;
                    channel: string;
                    id: string;
                    username: string
                    currency: string;
                };
            };
        }

        export interface Plane extends Response
        {
            speed: number;
            distance: number;
        }

        export interface History extends Response
        {
            timestamp: string;
            game_round_id: string;
            result: number;
        }

        export interface Limit extends Response
        {
            min: number;
            max: number;
            step?: number;
        }

        export interface _BetData extends Response
        {
            amount: number;
            cashoutAt: number;
            currency: string;
            id: string;
            payoutMultiplier?: number;
            result: "pending" | "cashed_out" | "lost";
            updatedAt: string;
            user: {
                id: string;
                name: string;
                avatar: string;
            };
            winAmount?: number;

            gameRoundId: number;
            roundMultiplier?: number;
        }

        export interface BetData extends Response
        {
            game_round_id: number; // gameRoundId
            bet_id: number; // id
            
            player_id: number; // user.id
            username: string; // user.name
            
            bet_amount: string; // amount
            cashout_at?: number; 
            
            multiplier?: string; // cashoutAt
            win_amount?: string; // winAmount
            
            crashpoint?: string; // roundMultiplier
            
            timestamp: string; // updatedAt
            
            // currently set manually
            player_avatar: string; // user.avatar
            currency: string; 
        }

        export interface Pong extends Response
        {
            time: number;
        }

        export interface Init extends Response
        {
            state: State;
            game_round_id: string;

            round_start_time: number;
            server_timestamp: number;

            starting_state_duration: number;

            plane: Plane;

            active_player_bets: Record<number, BetData>;
            
            all_bets: Record<number, BetData>;
            total_bet_count: number;

            game: {
                history: Array<History>;
                limits: {
                    bet: Limit;
                    cashout_at: Limit;
                    coin_denominations: Array<number>;
                    max_bets: number;
                    max_win: number;
                };
            };
        }

        export interface GameState extends Response
        {
            plane: Plane;
            state: State;
        }

        export interface GameStateStarting extends Response
        {
            plane: Plane;
            state: State;
            game_round_id: string;
            round_start_time: number;
            server_timestamp: number;
        }

        export interface CashedIn extends Response
        {
            bets: Record<number, BetData>
            total_bet_count: number;
        }

        export interface CashedOut extends Response
        {
            bets: Record<number, BetData>;
        }

        export interface Bet extends Response
        {
            bet_id: number;
            error: BetError;
        }

        export interface CancelBet extends Response
        {
            bet_id: number;
            error: BetError;
        }

        export interface Cashout extends Response
        {
            win_amount: string;
            multiplier: string;
            bet_id: number;
            error: CashoutError;
        }

        export interface MyBets extends Response
        {
            bets: Array<BetData>
        }

        export interface PreviousBets extends Response
        {
            previous_round_crashpoint: number;
            previous_round_bets: Array<BetData>
            previous_round_total_bet_count: number;
        }

        export interface Leaderboard extends Response
        {
            type: LeaderboardType;
            period: LeaderboardPeriod;
            data: Array<BetData>;
        }

        export interface BalanceUpdate extends Response
        {
            balance: number;
        }

        export interface Error extends Response
        {
            type: "NEW_CONNECTION";
        }

        export interface Chat extends Response
        {
            sender: string;
            player_id: number;
            timestamp: string;
            type: "player" | "share" | "gif" | "bot" | "server" | string;
            message: string | (BetData & {message: string});
            
            data?: BetData;
            avatar: string;
            likes: number;
            liked: boolean;

            id: number;

        }


        export interface ChatPlayersCount extends Array<ChatPlayer>
        {

        }


        export interface ChatPlayer extends Array<any>
        {

        }


        export interface Gifs extends Response
        {
            gifs: Array<{
                url: string;
                preview: string;
            }>;
        }


    }


}

// @ts-ignore
window.Comm = Comm;